"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DEFAULT_CONFIG = {
  host: ''
};
var _default = exports.default = DEFAULT_CONFIG;
//# sourceMappingURL=default-config.js.map